import styled from '@emotion/styled';

export const StyledSchemaListTitle = styled('h1')({
  fontSize: '1.75rem',
  fontWeight: 600,
  lineHeight: 1.2,
  marginBottom: 2,
  marginTop: 0,
});
